<template>
    <aside data-dialog="true" class="bg-white shadow-xl-heavy">
        <ul class="text-sm bg-white w-full py-2">
            <li v-for="option in options" class="type-primary border-b w-full last-of-type:border-b-0">
                <button @click="option.function" class="py-3 px-5 w-full flex items-center gap-4">
                    <BaseSvg :name="option.svg" class="h-6 w-6" :class="option.isToggled ? 'fill-red': ''" aria-hidden="true" />
                    {{ option.name }}
                </button>
            </li>
        </ul>
    </aside>
</template>

<script setup>
import {
    eventBus,
    useDialog,
    useMobileOptionsDialog,
    usePinsDrawer,
    usePrintDialog,
    useProductOptionsDialog,
    useShareDialog,
} from "@/Composables";
import { BaseSvg } from "@/Components";
import {computed, inject, onMounted, ref} from "vue";

const route = inject("route");
const props = defineProps(["data"]);
const { toggleMobileOptionsDialog } = useMobileOptionsDialog();
const { toggleProductOptionsDialog } = useProductOptionsDialog();
const { toggleShareDialog } = useShareDialog();
const {togglePrintDialog} = usePrintDialog();
const { forceClose } = useDialog();
const { fetchPin, togglePin } = usePinsDrawer();
let isPinned = ref(false);

function onPinFetched(pinData) {
    if(pinData) {
        isPinned.value = true;
    }
}

function onPinToggled() {
    isPinned.value = !isPinned.value;
}

onMounted(() => {
    fetchPin('item', props.data.card?.item_reference_id);
    eventBus.on('pins:pin-fetched', onPinFetched)
});

const options = computed(() => [
    {
        name: isPinned.value ? 'Remove from favorites' : 'Add to favorites',
        svg: isPinned.value ? 'icon-heart-filled' :'icon-heart-outline',
        isToggled: isPinned.value ?? false,
        function: () => {
            onPinToggled();
            togglePin('item', props.data.card?.item_reference_id);
        },
    },
    {
        name: "Add to list",
        svg: "icon-addition-sign",
        isToggled: false,
        function: (event) => toggleProductOptionsDialog(event, props.data),
    },
    {
        name: "Share cut sheet",
        svg: "icon-short-cut",
        isToggled: false,
        function: (event) => toggleShareDialog(event, {'sku': props.data?.card?.display_sku, 'slug': props.data?.card?.slug}),
    },
    {
        name: "Print product specs",
        svg: "icon-printer",
        isToggled: false,
        function: (event) => togglePrintDialog(event, ''),
    },
    {
        name: "Cancel",
        svg: "",
        isToggled: false,
        function: () => forceClose(),
    },
]);
</script>
